import { V1AreasOfImprovement } from "../../types";

export const meta: V1AreasOfImprovement = {
    practical: {
        missionalHiring: {
            title: "Missional Hiring",
            prologue:
                "The school hires faculty and staff who are rooted in their faith and support the school’s beliefs and mission (Amos 3:3; 2 Corinthians 6:14). ",
        },
        parentalProtection: {
            title: "Parental Protection",
            prologue:
                "Parents provide a healthy “hedge of protection” for their children from potentially harmful content (Job 1:10).",
        },
        familyDevotions: {
            title: "Family Devotions",
            prologue:
                "Parents and students report spending time in their families reading and praying together (Deuteronomy 6:7; Joshua 24:15; Psalms 78, 127).",
        },
        guardingTheMission: {
            title: "Guarding The Mission",
            prologue: "Board members feel confident that the school will guard its mission (1 Timothy 6:20). ",
        },
        biblicalPerspectives: {
            title: "Biblical Perspectives",
            prologue:
                "From the perspective of alumni, the school provided students opportunities to engage with biblical perspectives on social and political issues (Romans 12:2; Ephesians 2:1-2; Colossians 2:8).",
        },
        equippingForGoodWork: {
            title: "Equipping For Good Work",
            prologue:
                "Administrators and staff believe the school provides students with practical skills for evaluating the world and stewarding their health and financial resources (Proverbs 22:6; Luke 6:40; 1 Timothy 4:8; 2 Timothy 3:16).",
        },
        sabbathKeeping: {
            title: "Sabbath Keeping",
            prologue:
                "The school has policies to help personnel and families keep the Sabbath and communicates these expectations (Exodus 20:8-11; Deuteronomy 5:12-15; Hebrews 4:1-13).",
        },
        specialEducationInclusion: {
            title: "Special Education Inclusion",
            prologue:
                "The school’s special education practices welcome students with special needs and honor them as image bearers (Psalm 139:13-16; Mark 10:14; John 9:1-3).",
        },
    },
    intellectual: {
        integratingFaithAndLearning: {
            title: "Integrating Faith And Learning",
            prologue:
                "Students see how their academic work helps them better understand God’s character and the Bible’s teachings (Philippians 2:5; 1 Corinthians 2:14-16; Romans 8:6-7; Matthew 12:25, 30).",
        },
        teacherWorldviewTraining: {
            title: "Teacher Worldview Training",
            prologue:
                "The school trains teachers in their biblical worldview and evaluates their growth (Ezra 7:10; Romans 12:1-2; Colossians 3:10-11).",
        },
        faithBasedAccreditation: {
            title: "Faith Based Accreditation",
            prologue:
                "Board members see the value of the accreditation process in aligning the school with its Christian mission (Philippians 1:10; 1 Timothy 4:15; Colossians 3:10-11, 23; Hebrews 11:1; Luke 18:27).",
        },
        distinctivelyChristianEducation: {
            title: "Distinctively Christian Education",
            prologue:
                "Board members feel Christian education must be distinct in both content and pedagogy (2 Timothy 1:13, 3:16-17).",
        },
        integratingFaithAndTeaching: {
            title: "Integrating Faith And Teaching",
            prologue:
                "Teachers study how to integrate faith with their academic discipline and receive appropriate training (Romans 12:1-2; 1 Corinthians 11:1; 1 John 2:6).",
        },
        spiritualGuidance: {
            title: "Spiritual Guidance",
            prologue:
                "School personnel are open to guiding students with their questions and doubts about the Christian faith, and alumni recall the school providing a safe environment for questions (Acts 8:26-40; Luke 24:38; Jude 22).",
        },
    },
    heart: {
        spiritualMaturity: {
            title: "Spiritual Maturity",
            prologue:
                "Parents and teachers desire to grow in understanding and living according to the Bible (Hebrews 5:12-14, 6:1; John 15:5; Philippians 1:9).",
        },
        hopefulness: {
            title: "Hopefulness",
            prologue:
                "Students and alumni express optimism and purposefulness about their lives (Job 13:15; Jeremiah 29:11; Romans 5:5).",
        },
        reconciliation: {
            title: "Reconciliation",
            prologue:
                "Students seek forgiveness from others and offer forgiveness when it is asked of them (Matthew 6:15; Ephesians 4:32; Colossians 3:13).",
        },
        churchEngagement: {
            title: "Church Engagement",
            prologue: "Administrators are deeply devoted to a local church body (Romans 12:4-5; Hebrews 10:25).",
        },
        reverence: {
            title: "Reverence",
            prologue:
                "Administrators, staff, and students revere God and live their lives in submission to His authority (1 Samuel 12:24; Proverbs 1:7; Hebrews 12:9; 2 Timothy 3:16-17).",
        },
        personalDevotions: {
            title: "Personal Devotions",
            prologue:
                "Administrators, teachers, alumni, and staff are diligent about engaging with the Bible, including reading and memorizing Scripture (Psalms 19:7-8; 119:15).",
        },
    },
    nurture: {
        churchSchoolCongruence: {
            title: "Church School Congruence",
            prologue:
                "Students recognize how the teachings of their school and church agree with each other (Romans 12:4-5; Hebrews 10:25).",
        },
        mentoringLeaders: {
            title: "Mentoring Leaders",
            prologue:
                "Administrators have been mentored by other leaders and embody servant leadership by mentoring others (1 Corinthians 4:17; Philippians 2:22; 1 Timothy 1:2).",
        },
        peerEncouragement: {
            title: "Peer Encouragement",
            prologue:
                "As “iron sharpens iron,” students feel supported by their peers in the Christian faith (Proverbs 27:17). ",
        },
        parentalEncouragement: {
            title: "Parental Encouragement",
            prologue:
                "Parents and students spend quality time with each other and engage in conversation about the Christian faith (Deuteronomy 6:7; Psalm 78:4). ",
        },
        parentPartnership: {
            title: "Parent Partnership",
            prologue:
                "Administrators understand the importance of a strong partnership between parents and the school for nurturing the child’s spiritual growth (Deuteronomy 6:7; Joshua 24:15; Psalms 78, 127). ",
        },
        faithfulFriends: {
            title: "Faithful Friends",
            prologue:
                "Alumni report maintaining close friendships with friends from school, who continue to be strong in their faith (Proverbs 18:24). ",
        },
        supportiveCulture: {
            title: "Supportive Culture",
            prologue:
                "Alumni recall being supported by members of the school community (Galatians 6:2; Colossians 3:13). ",
        },
        spiritualGrowth: {
            title: "Spiritual Growth",
            prologue:
                "Administrators, teachers, and staff feel supported in their spiritual health and growth (2 Peter 3:18; Colossians 2:6-7; Psalm 92:12-14). ",
        },
    },
};
